// extracted by mini-css-extract-plugin
export default {"product-price":"mAZF70It--ProductPrice_product-price__mMBbA","productPrice":"mAZF70It--ProductPrice_product-price__mMBbA"};